module.exports = __webpack_public_path__ + "static/media/upgrade.e393ac76.svg";